export const SYSTEM_VARIABLES = [
  "company_name_call",
  "current_dt",
  "policy_number",
  "product_name",
  "nominee_name",
  "pending_premium",
  "premium_frequency",
  "modal_premium",
  "term_start_date",
  "sum_assured",
  "fund_value",
  "category",
  "policy_term",
  "premium_payment_term",
  "payment_due_date",
  "policy_status",
  "effective_charges_till_date",
  "effective_charges_rest_period_8",
  "maturity_value_at_8_percent",
  "helpline_number",
  "website_url",
  "email",
  "customer_name",
  "branded_farewell"
];

export const VARIABLE_OPTIONS = SYSTEM_VARIABLES.map((variable) => ({
  value: variable,
  label: `{${variable}}`
}));

export const SECTION_META = {
  welcome_message: {
    title: "Greeting (Opening)",
    description: "Welcome the customer and introduce the agent.",
    placeholder: "Hello {customer_name}, I am calling from {company_name_call}...",
    type: "greeting"
  },
  mandatory_disclosures: {
    title: "Mandatory (Compliance / Disclosures)",
    description: "Regulatory compliance, disclaimers & mandatory disclosures.",
    placeholder: "Please note that this call is recorded for quality and compliance purposes...",
    type: "mandatory"
  },
  scenarios: {
    title: "Scenarios",
    description: "Write dynamic use-case scenarios the agent should handle..",
    placeholder: "Configure dynamic use-case scenarios...",
    type: "scenario"
  },
  rebuttals_faqs: {
    title: "Rebuttals / FAQs",
    description: "Answer common questions and handle objections.",
    placeholder: "If the customer asks about pricing, trust, or policy details...",
    type: "faq"
  },
  final_call_message: {
    title: "Closing (Call to Action)",
    description: "Confirm the next action, thank the customer, and close the call.",
    placeholder: "Thank you for your time. Have a wonderful day ahead!",
    type: "closing"
  },
  more_info: {
    title: "More Info",
    description: "Extra resources, documentation links & follow-up data.",
    placeholder: "Provide extra follow-up resources and links...",
    type: "more_info"
  }
};

export const parseVariables = (text = "") => {
  if (!text || typeof text !== "string") return [];
  const regex = /\{([a-zA-Z0-9_]+)\}/g;
  const matches = new Set();
  let match;
  while ((match = regex.exec(text)) !== null) {
    matches.add(match[1]);
  }
  return Array.from(matches);
};

export const normalizeSections = (selectedAgent) => {
  if (!selectedAgent) return [];

  let sections = selectedAgent.prompt_sections || selectedAgent.user_defined_prompt || [];

  if (typeof sections === "string") {
    try {
      sections = JSON.parse(sections);
    } catch (e) {
      sections = [];
    }
  }

  if (!Array.isArray(sections)) {
    sections = [];
  }

  if (sections.length === 0) {
    return [
      { id: "welcome_message", title: SECTION_META.welcome_message.title, prompt: selectedAgent?.welcome_message || "" },
      { id: "mandatory_disclosures", title: SECTION_META.mandatory_disclosures.title, prompt: "" },
      { id: "rebuttals_faqs", title: SECTION_META.rebuttals_faqs.title, prompt: "" },
      { id: "final_call_message", title: SECTION_META.final_call_message.title, prompt: selectedAgent?.final_call_message || "" }
    ];
  }

  return sections;
};
